<template>
  <div id="report" style="height:100%;">
    <div class="block">
      
      <el-row type="flex" class="row-bg" justify="space-around">
        <el-col :span="6"><div class="grid-content bg-purple">订单号：{{order.code}}</div></el-col>
        <el-col :span="6"><div class="grid-content bg-purple-light">子单数：{{order.ordercount}}</div></el-col>
        <el-col :span="6"><div class="grid-content bg-purple">客户：{{order.customer}}</div></el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="space-around">
        <el-col :span="6"><div class="grid-content bg-purple">订单交期：{{order.time}}</div></el-col>
        <el-col :span="6"><div class="grid-content bg-purple-light">工序进度：{{order.ratio}}</div></el-col>
         <el-col :span="6"><div class="grid-content bg-purple"></div></el-col>
        </el-row>
    </div>
    
      <el-scrollbar >
        <div style="margin-top:10px;">
        <el-table :data="tableData" stripe width=80%  class="table_data" >
            <el-table-column prop="orderCode" label="编号" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.$index+1}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="partCode" label="物料编码" how-overflow-tooltip></el-table-column>
            <el-table-column prop="partMaterialName" label="物料名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="partCount" label="数量" show-overflow-tooltip></el-table-column>
            <el-table-column prop="useDay" label="已进行时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="startTime" :formatter="parseStartDate" label="计划开工日期" show-overflow-tooltip></el-table-column>
            <el-table-column prop="planningEndTime" :formatter="parseEndDate" label="计划完工日期" show-overflow-tooltip></el-table-column>
            <el-table-column prop="actualStartTime" :formatter="parseActualStartDate" label="实际开工日期" show-overflow-tooltip></el-table-column>
            <el-table-column prop="actualEndTime" :formatter="parseActualEndDate" label="实际完工日期" show-overflow-tooltip></el-table-column>
        </el-table>
        </div>
      </el-scrollbar>
    
    
  </div>
</template>


<script>
export default {
  name: "ProductionReportInfo",
  data() {
    return {
      tableData:[],
      orderId : this.$route.query.orderId,
      order:{
          code:"-",
          ordercount:"-",
          customer:"-",
          time:"-",
          ratio:"-"
      }
    };
  },
  mounted: function() {
    this.init();
  },
  
  methods: {
    init: function() {
      this.search();
    },
    reload(id){
      if(id){
        this.orderId = id
      }
      this.search()
    },
    clickSearch: function() {
      var dateRange = this.dateRange;
      if (dateRange == null || dateRange[0] == null || dateRange[1] == null) {
        this.$message.warning("请选择完整的时间区间");
        return
      }
      this.search();
    },
    search:function(){
        let params = {
          businessOrderId :this.orderId
        }
        this.$RequestUtil.get({
            url: '/api/report/getOrderDetailReport',
            type:'sync',
            params: params,
            success: (res) => {
                if(res.msg == "success"){
                    this.order.code = res.data.businessOrder.orderCode;
                    this.order.ordercount = res.data.list.length;
                    this.order.customer = res.data.businessOrder.orderCustomerName;
                    this.order.time = commonUtils.timestampToDate(res.data.businessOrder.deliverTime,true);
                    this.order.ratio = res.data.businessOrder.processRatio + "%";
                    if(res.data.list.length == 0){
                        this.$message.warning('未生成子订单');
                    }
                    let tableDate = res.data.list;
                    for(let i = 0 ; i < tableDate.length ; i++){
                      if(tableDate[i].actualStartTime == null){
                        tableDate[i].useDay = "0.0天";
                      }else if (tableDate[i].actualStartTime != null && tableDate[i].actualEndTime != null){
                        tableDate[i].useDay = this.calculate(tableDate[i].actualStartTime,tableDate[i].actualEndTime);
                      }else{
                        tableDate[i].useDay = this.calculate(tableDate[i].actualStartTime,(new Date()).valueOf());
                      }
                    }

                    this.tableData = res.data.list;
                    this.tableTotalPage = res.totalPages;
                }else{
                    this.$message.error(res.message||res.msg)
                }
            }
        });
    },
    parseStartDate:function(time){
        if(time != null){
            let dateString = commonUtils.timestampToDate(time.startTime,true);
            return dateString;
        }
    },
    parseEndDate:function(time){
        if(time != null){
            let dateString = commonUtils.timestampToDate(time.planningEndTime,true);
            return dateString;
        }
    },
    parseActualStartDate:function(time){
        if(time != null){
            let dateString = commonUtils.timestampToDate(time.actualStartTime,true);
            return dateString;
        }
    },
    parseActualEndDate:function(time){
        if(time != null){
            let dateString = commonUtils.timestampToDate(time.actualEndTime,true);
            return dateString;
        }
    },
    parseRatio:function(rowData){
        if(rowData.processRatio != null){
            return rowData.processRatio+'%';
        }
    },
    calculate:function(begin ,end){
      var seconds = (end - begin);
      var day = parseInt (seconds /(1000 * 60 * 60 * 24));
      var mod = seconds % (1000 * 60 * 60 * 24);
      var half = "";
      if(mod > 1000 * 60 * 60 * 12){
        half = ".5天"
      }else{
        half = ".0天"
      }
      return day+half;
    }
  }
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  background-color: #f0f0f0;
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/report/ProductionReportInfo.vue